import instance from 'api/instance';
import {
  ICreateTimeslot,
  IDeleteTimeslot,
  IGetTimeslot,
  IGetTimeslotById,
  ITimeslot,
  IUpdateTimeslot,
} from './types';
import qs from 'query-string';

export const getTimeslots: IGetTimeslot = (params) =>
  instance.get(`/timeslots?${qs.stringify(params)}`);

export const getTimeslotById: IGetTimeslotById = (id) =>
  instance.get(`/timeslots/${id}`);

export const createTimeslot: ICreateTimeslot = (timeslot) =>
  instance.post('/timeslots', timeslot);

export const updateTimeslot: IUpdateTimeslot = (id, timeslot) =>
  instance.put(`/timeslots/${id}`, timeslot);

export const deleteTimeslot: IDeleteTimeslot = (id) =>
  instance.delete(`/timeslots/${id}`);
